import * as React from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import {
  RiFileEditLine,
  RiCalculatorLine,
  RiArrowRightLine,
  RiPhoneLine,
  RiMapPin2Line,
  RiMailLine,
} from "react-icons/ri";

import Button from "../../Components/Button";

import Logo from "./../../Images/logo_white.png";

import { useLoader } from "../../Context/LoaderContext";

import "./FinancingRequestNotConnected.scss";

const ConfirmRequestNotConnected = () => {
  const [referenceSimulation, setReferenceSimulation] = React.useState([]);

  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "Access-Token": localStorage.getItem(
            process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
          ),
        },
      })
      .then((response) => {
        setIsLoading(false);
        setReferenceSimulation(response?.data?.data?.reference || {});
      })

      .catch((error) => {
        setIsLoading(false);
      });
  }, [setIsLoading]);

  return (
    <div className="layout-app layout-not-connected ">
      <div className="sideBar sideBar-not-connected">
        <Link to="/" className="logo logo-white">
          <img
            src={Logo}
            alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
          />
        </Link>
        <div className="title-sidebar-not-connected active">
          Lancez votre projet Leasing
        </div>
        <div className="menu-sidebar-not-connected">
          <RiCalculatorLine /> Simulations
        </div>
        <div className="menu-sidebar-not-connected active">
          <RiFileEditLine /> Demande de Financement
        </div>
      </div>
      <div className="wrap-app wrap-app-not-connected justify-content-center">
        <div className="container-app container-app-not-connected">
          <div className="wrap-confirm-request">
            <div className="title-confirm-request">
              Confirmation de Soumission de la Demande
            </div>
            <div className="sub-title-confirm-request">
              Notre équipe examinera les informations et les documents fournis.
              Vous serez contacté par notre service client sous peu pour la
              suite du traitement de votre demande.
            </div>
            <div className="box-folder-number">
              <div className="title-folder-number">Numéro de Dossier</div>
              <div className="folder-number">{referenceSimulation}</div>
            </div>
            <div className="box-confiance">
              <div className="title-confiance">Merci de votre confiance</div>
              <div className="content-confiance">
                Si vous avez des questions ou des préoccupations,
                <br />
                n'hésitez pas à contacter notre service client
              </div>
            </div>
            <div className="wrap-adress-demande">
              
              <div className="box-adress-demande">
                <div className="icon-adress-demande">
                  <RiPhoneLine />
                </div>
                <div className="content-adress-demande">
                  <div className="title-adress-demande">Appelez nous</div>
                  <div className="caption-adress-demande">
                    (+216) 70 136 436 <br />
                    (+216) 39 140 836
                  </div>
                </div>
              </div>
              <div className="box-adress-demande">
                <div className="icon-adress-demande">
                  <RiMailLine />
                </div>
                <div className="content-adress-demande">
                  <div className="title-adress-demande">Adresse email </div>
                  <div className="caption-adress-demande">
                    <a href="mailto:service.client@attijarileasing.com.tn">
                      service.client@attijarileasing.com.tn
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap-link-request">
              <Button>
                <Link to="/">
                  Retour vers la page d'accueil
                  <RiArrowRightLine />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmRequestNotConnected;
